import { Box, Modal, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import React from "react";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import { useTranslation } from "react-i18next";

const DeleteFileModal = (props) => {
  const { handleClose, handleDelete, show, document } = props;
  const { originalFilename = {} } = document;
  const { t } = useTranslation();
  return (
    <div>
      <Modal
        open={show}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          borderRadius={3}
          border="none"
          padding={3}
          width={400}
          position="absolute"
          left={0}
          right={0}
          top="35%"
          marginLeft="auto"
          marginRight="auto"
          bgcolor="background.paper"
        >
          <Box display="flex" justifyContent="flex-end">
            <Close
              sx={{
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </Box>

          <Typography
            variant="h5"
            textAlign="center"
            maxWidth="250px"
            margin="auto"
          >
            {t("delete-file-message")}
          </Typography>
          <Typography textAlign="center" padding="2rem 0">
            {originalFilename}
          </Typography>
          <Box display="flex" justifyContent="center" marginTop={3}>
            <PrimaryButton
              title={t("Cancel")}
              click={handleClose}
              fullWidth={false}
              borderRadius={4}
              padding="0.4rem 2rem"
              textTransform="none"
            />
            <SecondaryButton
              title={t("Delete")}
              click={async () => {
                await handleDelete();
                handleClose();
              }}
              fullWidth={false}
              padding="0.4rem 2rem"
              borderRadius={4}
              border="3px solid #c298bb"
              marginLeft={3}
              textTransform="none"
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default DeleteFileModal;
